import React from "react";
import { Link } from "react-router-dom";
import { BrandMark } from "./BrandMark";
import { useAuth } from "../contexts/AuthContext";
import { homeForRole } from "../lib/roleHome";

/**
 * Logo home-link.
 *
 * Wraps <BrandMark/> in a React Router <Link> so that:
 * - signed-out clicks/⌘-clicks/right-clicks → "/"
 * - customer → "/customer/dashboard"
 * - staff   → "/staff/scanner"
 * - admin / manager → "/admin/dashboard"
 *
 * Using <Link> (not <button onClick={navigate}>) preserves browser native
 * affordances like middle-click-new-tab and "Open Link in New Tab".
 *
 * Props: `size`, `theme`, `className` forwarded to BrandMark.
 * `testId` defaults to "brand-home-link" and may be overridden per layout.
 */
export const BrandMarkLink = ({
  size = "sm",
  theme = "dark",
  className = "",
  testId = "brand-home-link",
  ariaLabel = "Napoli home",
}) => {
  const { user } = useAuth();
  const target = user ? homeForRole(user.role) : "/";

  return (
    <Link
      to={target}
      data-testid={testId}
      aria-label={ariaLabel}
      className="inline-flex items-center group focus:outline-none focus-visible:ring-2 focus-visible:ring-napoli-oxblood/50"
    >
      <BrandMark
        size={size}
        theme={theme}
        className={`group-hover:opacity-90 transition-opacity ${className}`}
      />
    </Link>
  );
};

export default BrandMarkLink;
